import axios from 'axios';
import store from '@/models/store.js';

const Client = axios.create({
  baseURL: process.env.API_ENDPOINT,
});

Client.interceptors.request.use((config) => {
  store.dispatch('changeAxiosLoadingStatus', { status: true });
  if (store.getters.token !== '') {
    config.headers.Authorization = `Bearer ${store.getters.token}`;
    return config;
  }
  return config;
});

Client.interceptors.response.use(
  (response) => {
    store.dispatch('changeAxiosLoadingStatus', { status: false });
    return response;
  },
  (error) => {
    store.dispatch('changeAxiosLoadingStatus', { status: false });
    return Promise.reject(error);
  },
);

export default Client;



// WEBPACK FOOTER //
// ./src/utilities/client.js